"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxeptaResponseStatusMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class AxeptaResponseStatusMapper {
    toDomain(result) {
        var _a, _b, _c;
        return {
            transactionSuccess: lodash_1.default.get(result, "data.axeptaV2Status.transactionSuccess"),
            refillSuccess: lodash_1.default.get(result, "data.axeptaV2Status.refillSuccess"),
            isNetworkError: lodash_1.default.get(result, "data.networkStatus") === 8,
            errorGroup: (_a = lodash_1.default.get(result, "data.axeptaV2Status.errorGroup")) !== null && _a !== void 0 ? _a : null,
            userMessage: (_b = lodash_1.default.get(result, "data.axeptaV2Status.userMessage")) !== null && _b !== void 0 ? _b : null,
            errorAction: (_c = lodash_1.default.get(result, "data.axeptaV2Status.errorAction")) !== null && _c !== void 0 ? _c : null,
        };
    }
}
exports.AxeptaResponseStatusMapper = AxeptaResponseStatusMapper;
